<template>
  <!-- 国内省市区三级地址树 v2 -->
  <popup :show="show"
         title="所在地区"
         :confirm-btn="false"
         @close="() => { $emit('close') }">
    <div class="cascader-container">
      <div class="top-search">
        <div class="search-input">
          <i class="iconfont icon-search btn-search" :class="PostUiIcon.search" />
          <input ref="searchInput"
                 v-model.trim="searchVal"
                 type="text"
                 placeholder="请输入省份/城市/区县搜索"
                 @input="handleInput()">
          <i v-show="searchVal"
             class="iconfont icon-close-circle btn-clear"
             @click.stop="() => { searchVal = '' }" />
        </div>
        <!-- <button v-if="searchVal"
                type="button"
                class="btn-confirm"
                @click="handlerSearch()">
          搜索
        </button> -->
      </div>
      <template v-if="!searchVal">
        <div class="cascader-popular">
          <p class="title">
            热门城市
          </p>
          <div class="popular-wrap">
            <!-- <div class="line" /> -->
            <ul class="popular-list">
              <li v-for="i in popularCitiesCode"
                  :key="i"
                  class="popular-item"
                  :class="{ 'active': isActivePopularCitiesTab(i) }"
                  @click="handlePopularTabClick(i)">
                {{ (getPopularCity(i) && getPopularCity(i).areaName) }}
              </li>
            </ul>
          </div>
        </div>
        <div class="cascader-tabs">
            <div v-for="(item, index) in selectCascader"
                 v-show="isActiveCascaderTab(item, index)"
                 :key="index"
                 class="cascader-tab"
                 :class="{'is-active': tabActiveIndex == index}"
                 @click="handleCascaderTabClick(index)">
              <div class="tab-title">
                {{ (item && item.areaName) || ['请选择省份', '请选择城市', '请选择区县'][index] }}
              </div>
            </div>
        </div>
        <div class="cascader-list">
          <div v-for="(item, index) in currentListData"
               :key="index"
               class="cascader-item"
               :class="{ 'active': isActiveCascaderItem(item) }"
               @click="handleCascaderItemClick(item)">
            <div class="cascader-name">
              <span class="item-index">
                {{ index === 0 ? item.headChar : '' }}
                {{ (index !== 0 && (currentListData[index].headChar !== currentListData[index - 1].headChar)) ?
                  item.headChar :
                  ''
                }}
              </span>
              <span>{{ item.areaName }}</span>
            </div>
            <i class="iconfont"
               :class="isActiveCascaderItem(item) ? 'icon-check-circle' : 'icon-check-button-off'" />
          </div>
        </div>
      </template>
      <!-- 搜索结果 -->
      <div v-if="searchVal" class="cascader-list">
        <div v-for="(item, index) in searchList"
             :key="'search' + index"
             class="cascader-item"
             @click="handleSearchItemClick(item)">
          <p class="cascader-name">
            <span class="item-index"></span>
            <span v-html="highlightText(`${item[0].areaName}-${item[1].areaName}-${item[2].areaName}`, searchVal)"></span>
          </p>
        </div>
        <no-result-box v-if="!searchList.length" resultNull="暂无内容"></no-result-box>
      </div>
    </div>
  </popup>
</template>
<script>
import popup from '@/components/popup/index.vue'
import { highlightText, debounce } from '@/plugin/commonUse.js'
import NoResultBox from '@/components/noResult/NoResultBox.vue'

export default {
  name: 'cascaderPopup',
  mixins: [],
  components: {
    popup,
    NoResultBox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      popularCitiesCode: ['110100', '310100', '440100', '440300', '330100', '320100', '510100', '420100'],
      /** 当前展示的数据 */
      currentListData: [],
      /** 已选择的cascader联动 */
      selectCascader: [],
      tabActive: 0, // tab选中
      /** 搜索关键字 */
      searchVal: '',
      searchList: []
    }
  },
  computed: {
    highlightText () {
      return highlightText
    },
    tabActiveIndex () {
      if (this.currentListData && this.currentListData[0]) {
        return (this.currentListData[0].areaLevel) - 1
      }
      return 0
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.handlePropsValue(this.value)
      }
    },
    options (val) {
      this.currentListData = val
    }
  },
  filters: {},
  directives: {},
  created () {
    this.selectCascader.length = 3
  },
  mounted () {
  },
  methods: {
    handlePropsValue (code) {
      this.selectCascader.fill(undefined)
      let data = this.getPopularCity(code)
      const index = data?.areaLevel
      let areaLevel = data?.areaLevel || ''
      if (areaLevel === '3') {
        // 区
        this.selectCascader[2] = data
        areaLevel = '2'
        data = this.getPopularCity(data?.parentAreaCode)
      }
      if (areaLevel === '2') {
        // 市
        if (data?.areaLevel === '1') {
          // 直辖市
          this.selectCascader[1] = data?.childArea[0]
          areaLevel = '1'
        } else {
          this.selectCascader[1] = data
          areaLevel = '1'
          data = this.getPopularCity(data?.parentAreaCode)
        }
      }
      if (areaLevel === '1') {
        // 市
        this.selectCascader[0] = data
      }
      if (index === '3' || index === '2') {
        this.currentListData = this.selectCascader[1]?.childArea
      }
    },
    /** 热门城市点击事件 */
    handlePopularTabClick (code) {
      const city = this.getPopularCity(code)
      const province = this.getPopularCity(city.parentAreaCode)
      this.selectCascader[0] = province
      this.selectCascader[1] = city
      this.selectCascader[2] = undefined
      this.currentListData = city?.childArea
      this.$emit('change', {
        selectedOptions: (this.selectCascader),
        tabIndex: 1,
        value: code || ''
      })
    },
    /** 控制热门城市是否选中 */
    isActivePopularCitiesTab (code) {
      return this.selectCascader[1]?.areaCode === code || this.selectCascader[1]?.parentAreaCode === code
    },
    /** 联动标题点击事件 */
    handleCascaderTabClick (index) {
      if (index === 2) return false
      if (index === 0) {
        this.currentListData = this.options
        this.selectCascader.fill(undefined)
      } else {
        this.currentListData = this.selectCascader[index - 1].childArea
        this.selectCascader.fill(undefined, index + 1)
      }
      this.$emit('change', {
        selectedOptions: (this.selectCascader),
        tabIndex: index,
        value: this.selectCascader[index]?.areaCode || ''
      })
    },
    /** 控制联动标题是否显示 */
    isActiveCascaderTab (item, index) {
      // this.currentListData[0]?.areaLevel 当前列表渲染的数据层级，控制【请选择】显示
      // item?.areaLevel 联动列表selectCascader某一项已选择的数据，控制标题省市区名称显示
      const level = index + 1
      return +this.currentListData[0]?.areaLevel === level || +item?.areaLevel === level
    },
    /** 联动选项点击事件 */
    handleCascaderItemClick (data) {
      // 根据树形层级进行赋值
      const index = (+data.areaLevel) - 1
      if (index < 3) {
        this.currentListData = data.childArea.length > 0 ? data.childArea : this.currentListData
        this.selectCascader[index] = data
      }
      // 选择结束
      if (index === 2) {
        this.$emit('finish', {
          selectedOptions: (this.selectCascader),
          tabIndex: index,
          value: data?.areaCode || ''
        })
      }
      this.$emit('change', {
        selectedOptions: (this.selectCascader),
        tabIndex: index,
        value: data?.areaCode || ''
      })
    },
    /** 控制联动选项是否选中 */
    isActiveCascaderItem (item) {
      return this.selectCascader[+item.areaLevel - 1]?.areaCode === item?.areaCode
    },
    /** 遍历树形数据 */
    findNode (tree, func) {
      for (const node of tree) {
        if (func(node)) return node
        if (node.childArea) {
          const res = this.findNode(node.childArea, func)
          if (res) return res
        }
      }
      return null
    },
    /** 根据城市编码遍历树形数据得到热门城市 */
    getPopularCity (code) {
      return this.findNode(this.options, (node) => {
        return node.areaCode === code
      })
    },
    /**
     * 搜索相关
     */
    // 输入搜索 防抖
    handleInput: debounce(function () {
      if (!this.searchVal || this.searchVal.length < 2) {
        this.searchList.length = 0
        return
      }
      const fuzzyList = this.fuzzySearch(this.searchVal, this.options)
      this.searchList = this.tilingArray(fuzzyList)
      console.log('搜索列表')
      console.log(this.searchList)
    }, 650),
    // 搜索遍历，符合数据的路径提取出来
    fuzzySearch (query, list) {
      const _list = JSON.parse(JSON.stringify(list))
      return _list.filter((item) => {
        if (item.areaName.includes(query)) {
          return true
        }

        if (item.childArea) {
          item.childArea = this.fuzzySearch(query, item.childArea)
          return item.childArea.length > 0
        }
        return false
      })
    },
    // 处理三层平铺为一层
    tilingArray (list, secondItem = {}, firstItem = {}) {
      let result = []

      list.forEach(item => {
        if (item.childArea && item.childArea.length) {
          this.tilingArray(item.childArea, item, secondItem)
          result = result.concat(this.tilingArray(item.childArea, item, secondItem))
        } else {
          let arr = [] // 为了和省市区点击结束的数据差不多
          arr.push(firstItem)
          arr.push(secondItem)
          arr.push(item)
          if (item.areaName !== '暂不选择') {
            result.push(arr)
          }
        }
      })

      return result
    },
    // 搜索结果点击
    handleSearchItemClick (data) {
      this.$emit('finish', {
        selectedOptions: data,
        tabIndex: 3,
        value: data[2]?.areaCode || ''
      })
      this.searchVal = ''
    }
  }
}

</script>
<style lang="scss" scoped>
@import "./index";
</style>
